/** @jsx h */

/* eslint-disable */

import {h, render} from "preact"
import {useState, useEffect} from "preact/hooks"
// import "url-polyfill"
let {gettext, interpolate} = window // eslint-disable-line

if (typeof gettext === 'undefined') {
    gettext = str => str
}
let _T_result = gettext("Search")
let _T_searchhelper = gettext("Results for")
let _T_more = gettext("Load more results")
let _T_no_results = gettext("No results found.")
let _T_searching = gettext("Searching...")
let _T_next = gettext("More")

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach
}


const TEMPLATE = "https://www.googleapis.com/customsearch/v1?key=KEY&cx=CX&q=QUERY&start=STARTINDEX&callback=CALLBACK&lr=LANG"
const NO_QUERY = 1,
  DO_SEARCH = 2,
  SEARCHING = 3,
  SUCCESS = 4

const blacklist = ["https://www.cedes.com/", "https://www.cedes.com/de/", "https://www.cedes.com/en/"]

export function renderSearch(el) {
        render(<Search cseCx={el.dataset.cseCx} cseKey={el.dataset.cseKey} cseLang={el.dataset.cseLang}/>, el)
}

const loadResults = ({cseCx, cseKey, cseLang, query, startIndex}) => {
    window.history.replaceState({}, "", `?q=${query}`)

  const script = document.createElement("script")
  script.setAttribute("data-cse", "true")
  script.setAttribute(
    "src",
    TEMPLATE.replace(/KEY/, cseKey)
      .replace(/CX/, cseCx)
      .replace(/QUERY/, encodeURIComponent(query))
      .replace(/CALLBACK/, "cseHandler")
      .replace(/STARTINDEX/, startIndex)
      .replace(/LANG/, cseLang)
  )
  document
    .querySelectorAll("script[data-cse]")
    .forEach(el => el.parentNode.removeChild(el))
  document.body.appendChild(script)
}

const initialQuery = (() => {
  const url = new URL(document.location)
  return url.searchParams.get("q") || ""
})()

function Search({cseCx, cseKey, cseLang}) {
  const [query, setQuery] = useState(initialQuery)
  const [startIndex, setStartIndex] = useState(1)
  const [resultItems, setResultItems] = useState([])
  const [response, setResponse] = useState(null)
  const [currentState, setCurrentState] = useState(
    initialQuery ? DO_SEARCH : NO_QUERY
  )

  useEffect(() => {
    window.cseHandler = data => {
      setCurrentState(SUCCESS)
      setResponse(data)
      if (data.items) {
        setResultItems([...resultItems, ...data.items])
      }
    }
    return () => {
      window.cseHandler = null
    }
  })

  useEffect(
    () => {
      // Actually load those results
      if (currentState === DO_SEARCH) {
        setCurrentState(SEARCHING)
        loadResults({cseCx, cseKey, cseLang, query, startIndex})
      }
    },
    [currentState, startIndex]
  )

  return (
      <div>
          <form
              method="get"
              onSubmit={e => {
                  e.preventDefault()
                  setCurrentState(DO_SEARCH)
                  setStartIndex(1)
                  setResultItems([])
              }}
          >
              <div className="form-default">
                  <div className="form-group">
                      <div className="input-group">
                          <input
                              className="search-field form-control"
                              type="text"
                              name="q"
                              value={query}
                              onChange={e => setQuery(e.target.value)}
                              id="id_q"
                          />

                          <div className="search-button input-group-btn">
                              <button className="btn btn-default" type="submit">
                                  {_T_result}
                              </button>
                          </div>
                      </div>

                  </div>

                  <div className="search-result__text">
                      {query ? (
                          <p className="search-result__helper">
                              {_T_searchhelper} <span className="highlighted">{query}</span>
                              :
                          </p>
                      ) : null}
                  </div>
              </div>
          </form>

      {currentState === SUCCESS || resultItems.length ? (
        <ResultList
          resultItems={resultItems}
          hasNextPage={!!(response.queries && response.queries.nextPage)}
          cseLang={cseLang}
          onNextPage={() => {
            setCurrentState(DO_SEARCH)
            setStartIndex(response.queries.nextPage[0].startIndex)
          }}
        />
      ) : null}
      {currentState === SEARCHING ? (
        <div className="">
          <div className="search-result__searching">
            <h2>{_T_searching}</h2>
          </div>
        </div>
      ) : null}
    </div>
  )
}

const ResultList = ({resultItems, cseLang, hasNextPage, onNextPage}) => {
    let entries = resultItems.filter(entry => !blacklist.includes(entry.formattedUrl))

    if (cseLang == "lang_en") {
        entries = entries.filter(entry => entry.formattedUrl.indexOf("https://www.cedes.com/de/"))
    } else if (cseLang == "lang_de") {
        entries = entries.filter(entry => entry.formattedUrl.indexOf("https://www.cedes.com/en/"))
    }

    if (entries.length) {
    return (
      <section className="cbox search-results">
        <div className="search-results">
          {entries.map((item, index) => (
            <article className="search-card">
              <ResultItem key={index} {...item} />
            </article>
          ))}

          <br />

          {hasNextPage ? (
            <div className="">
              <div className="search-next-page">
                <button
                  type="button"
                  className="button-link-plugin__link  btn btn-default btn-md"
                  onClick={onNextPage}
                >
                  {_T_more}
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </section>
    )
  } else {
    return (
      <div className="">
        <div className="search-result__no-result text-container">
          <h3>{_T_no_results}</h3>
        </div>
      </div>
    )
  }
}

const ResultItem = props => {
  let thumbnailSrc
  let mimePdf
  let sharingImage = "https://cedesallink-test-d427ecb41da74e50b125e68467bc0a34-c86ad58.sos-ch-dk-2.exo.io:443/filer_public/4e/4e/4e4eb0a8-c68f-49ba-867b-7fe9f74b1e4e/cedes-og-image.jpg"
  let sharingImageEncrypted =
    "https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSn8XoMF82p_KkKfFwTLTVR62mMALYjk4RiHe_5dDdBNNFCsGlZLkd7wGhq"
  try {
      console.log(props);
      thumbnailSrc = props.pagemap.metatags[0]["og:image"]
      if (thumbnailSrc === sharingImage) {
      thumbnailSrc = props.pagemap.cse_thumbnail[0].src
    }
  } catch (e) {
    if (!props.pagemap) {
    } else if (!props.pagemap.cse_image) {
    } else {
      thumbnailSrc = props.pagemap.cse_image[0].src
    }
  }
    mimePdf = props.mime
    let mimeTypePdf = "application/pdf"
    if (thumbnailSrc === sharingImage || thumbnailSrc === sharingImageEncrypted) {
        thumbnailSrc = false
    }


    return (

        <div className="search-item">
            {mimePdf == mimeTypePdf ? (
                <div className="search-item__image">
                    <div className="pdf-icon"/>
                </div>
            ) : (
                thumbnailSrc && (
                    <div className="search-item__image">
                        <img src={thumbnailSrc} alt=""/>
                    </div>
                )
            )}
            <div className="search-item__content text-container">
                <a
                    className="heading search-result__title"
                    href={props.link}>
                    <h3 className="heading" dangerouslySetInnerHTML={{__html: props.pagemap.metatags[0]["og:title"]}}/>
                </a>

                <p className="search-result__content">{props.snippet}</p>
                <small style="text-decoration:underline">
                    <a className="app-list__detail-link" href={props.link}>{_T_next}</a>
                </small>
            </div>
        </div>

    )

}



// WEBPACK FOOTER //
// ./static/js/modules/search.js